import { Toast, ToastContainer } from "react-bootstrap";
// icon = checkCircleIcon, alertIcon, alertTriangleIcons

// toastVariant = success, info, danger, warning

function ToastAlerts(props) {
    const { icon, text, showToast, setShowToast, toastVariant } = props;
    return (
        <ToastContainer position="top-end" className="toast-alerts">
            <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide  bg={toastVariant}>
                <Toast.Header>
                    <div className="toast-text-wrap">
                        {icon}
                        <span className="toast-text">{text}</span>
                    </div>
                </Toast.Header>
            </Toast>
        </ToastContainer>
    );
}
export default ToastAlerts;